import { DataSourceFactory } from 'app/components'

interface IFoundationData {
  name: string
  location: string
  ein: string
}

interface Result {
  statusCode: number
  body: IFoundationData[]
  headers: any
}

const filterBody = { action: 'findafoundation', request: { assetLevel: 0, state: '', name: '', monthNumber: '12', city: '', zip: '' } }
const saveRequestBody = { ein: '', email: '' }

const FoundationSources = DataSourceFactory.create<Result>({
  transport: {
    read: {
      url: 'https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests',
      insertBodyBeforeRequest: () => JSON.stringify(filterBody),
      request: { method: 'POST' }
    }
  }
})

const SaveRequest = DataSourceFactory.create<{}>({
  transport: {
    read: {
      url: 'https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/saverequest',
      insertBodyBeforeRequest: () => JSON.stringify(saveRequestBody),
      request: { method: 'POST' }
    }
  }
})

const setRequestAndSend = (ein: string, email: string) => {
  saveRequestBody.ein = ein
  saveRequestBody.email = email

  SaveRequest.sync()
}

const filterAndSyncFoundationSource = (name: string, state: string, city: string, zip: string) => {
  filterBody.request.name = name
  filterBody.request.state = state
  filterBody.request.city = city
  filterBody.request.zip = zip

  FoundationSources.sync()
}

export {
  filterAndSyncFoundationSource,
  FoundationSources,
  setRequestAndSend,
  IFoundationData
}



// WEBPACK FOOTER //
// ./src/app/components/section/FindAFoundation/DataSources.ts